import { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { RegistrationContext } from '../../context/registration';

import { fetchCampaignContext } from '~/services/registration';
import { campaignGoal } from '../../services/start-campaign';

import { ProgressBar } from './ProgressBar';
import {
    Container,
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Form,
    FormGroup,
    Input,
    Label,
    FormText,
} from 'reactstrap';

import { Loading } from '../../shared/components/Loading';
import { currencyConfig } from '../../shared/components/form/Inputs';
import IntlCurrencyInput from 'react-intl-currency-input';

export const Goal = ({}: any) => {
    const [{ campaignRequest }, registrationDispatch] =
        useContext(RegistrationContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [goal, setGoal] = useState(0);
    const [showTherm, setShowTherm] = useState(false);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (campaignRequest) {
            setGoal(campaignRequest.campaign?.goal);
            setShowTherm(campaignRequest.campaign?.show_goal_bar);
            setLoading(false);
        } else {
            getCampaign();
        }
    }, [campaignRequest]);

    const getCampaign = async () => {
        const resp = await fetchCampaignContext();
        console.log('resp: ', resp);

        registrationDispatch({
            type: 'set_registration',
            payload: resp,
        });
    };

    const handleNext = async () => {
        try {
            setSaving(true);
            const payload = {
                goal,
                show_goal_bar: showTherm,
            };
            const resp = await campaignGoal(payload);

            history.push('/start-campaign/story');
        } catch (e) {
            setSaving(false);
            console.log('e: ', e);
        }
    };

    if (loading) {
        return <Loading />;
    }

    const disableNext = !goal;

    return (
        <Container>
            <ProgressBar selectedStep='goal' />
            <Row className='justify-content-center py-5'>
                <Col md='8'>
                    <div className='text-center'>
                        <h3>What is your goal with this campaign?</h3>
                    </div>

                    <Card
                        className='box-shadow my-5'
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <CardBody className='p-5'>
                            <Row className='justify-content-between'>
                                <Col md='6'>
                                    <Form>
                                        <FormGroup>
                                            <Label>Fundraising Goal *</Label>
                                            <IntlCurrencyInput
                                                onChange={(e, val, masked) => {
                                                    setGoal(val);
                                                }}
                                                className='form-control'
                                                config={currencyConfig}
                                                value={goal}
                                            />
                                            <FormText>
                                                Pre-filled from anticipated need
                                                found in Financial Information
                                                form, but can be updated here at
                                                anytime
                                            </FormText>
                                        </FormGroup>
                                        <FormGroup check className='mb-3'>
                                            <Label check>
                                                <Input
                                                    type='checkbox'
                                                    onChange={() =>
                                                        setShowTherm(!showTherm)
                                                    }
                                                    name='show_therm'
                                                    checked={showTherm}
                                                />
                                                Show fundraising thermometer on
                                                page
                                            </Label>
                                        </FormGroup>
                                        <div className='text-center'>
                                            <Button
                                                color='primary'
                                                onClick={handleNext}
                                                disabled={saving || disableNext}
                                            >
                                                {saving ? `Saving...` : `Next`}
                                            </Button>
                                        </div>
                                    </Form>
                                </Col>
                                <Col md='4'>
                                    <Card className='bg-lightblue'>
                                        <CardBody>
                                            <h3>Successful Campaign Tips</h3>Set
                                            a realistic fundraising goal. Your
                                            goal will determine how you
                                            communicate with your community.
                                            Think about your immediate and
                                            long-term medical and related
                                            expenses. Make a list. What amount
                                            will you need to raise to help cover
                                            your expenses? Be specific: consider
                                            small, large—even miscellaneous
                                            expenses. Keep in mind: that you can
                                            always reset your goal as your needs
                                            evolve and change.
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};
